import { render, staticRenderFns } from "./TiendasYFarmacias.vue?vue&type=template&id=ccc69614&scoped=true"
import script from "./TiendasYFarmacias.vue?vue&type=script&lang=ts"
export * from "./TiendasYFarmacias.vue?vue&type=script&lang=ts"
import style0 from "./TiendasYFarmacias.vue?vue&type=style&index=0&id=ccc69614&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc69614",
  null
  
)

export default component.exports